import React from 'react';
import ReactDOM from 'react-dom/client';
import '@wk/components-v3-react16/all.min.css';
import '@wk/components-v3-react16/theme-PDS-v3.min.css';
import '@wk/components-v3-react16/common-classes.min.css';
import {
  WkIconDefaultSprite,
  WkIconBookSprite,
  WkIconProcessListSprite,
  WkIconFilesSprite,
  WkIconUploadLineSprite,
  WkIconCheckCircleSprite,
  WkIconFileCompareSprite,
  WkIconUsersSprite,
  WkIconSettingsSprite,
} from '@wk/components-v3-react16';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.body.setAttribute('cg3-theme', 'PDS-v3');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <WkIconDefaultSprite />
    <WkIconBookSprite />
    <WkIconProcessListSprite />
    <WkIconFilesSprite />
    <WkIconUploadLineSprite />
    <WkIconCheckCircleSprite />
    <WkIconFileCompareSprite />
    <WkIconUsersSprite />
    <WkIconSettingsSprite />
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
